import React, { useState, useEffect } from "react";
import { getAspekOperasionalAll, getIndikatorKesehatanAll } from "../../api";
import { useSelector } from "react-redux";
import { isBiro } from "../../utils/helper";
import FormFilter from "./formFilter";
import API from "./../../utils/API";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";


const AspekKeuangan = () => {
  const [data, setData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [rawData, setRawData] = React.useState([]);
  const filter = useSelector((state) => state.filterReducer);
  const [loadingApi, setLoadingApi] = useState(true);

  const filterDashboard = useSelector(
    (state) => state.filterDashboard
  );

  const loadData = async () => {
    try {
      if (filterDashboard.bumd !== undefined && isBiro()) {
        var url =
          `/indikator-kesehatan/aspek-keuangan?type=${filterDashboard.type}&startMonth=${filterDashboard.startMonth}&endMonth=${filterDashboard.endMonth}&perusahaanId=${filterDashboard.bumd}&startYear=${filterDashboard.startYear}&endYear=${filterDashboard.endYear}`;
      }
      else {
        url =
          `/indikator-kesehatan/aspek-keuangan?type=${filterDashboard.type}&startMonth=${filterDashboard.startMonth}&endMonth=${filterDashboard.endMonth}&&perusahaanId=${user.perusahaan.id}&startYear=${filterDashboard.startYear}&endYear=${filterDashboard.endYear}`;
      }
      url = url.trim();
      const r = await API.get(url);
      const d = r.data;
      setData(d);
      setRawData(d);

    } catch (err) {
      toast.error(err.message, { position: toast.POSITION.BOTTOM_RIGHT });
    }
  };

  const rowHeaders = [
    "Hasil",
    "Score",
  ];

  React.useEffect(() => {
    loadData();
  }, [
    filterDashboard
  ]);
  return (
    <>

      <FormFilter />

      <div className="container-fluid mt-3">
        <div className="card container shadow-sm border-0">
          <div className="row">
            <div className="col py-3">
          {rawData.length === 0 || filterDashboard.bumd == undefined ? (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", fontStyle: "italic" }}>
                Data tidak tersedia
              </td>
            </tr>
          ) : (
            <table className="table table-responsive table-bordered">
              <tr >
                <th></th>
                {data.map((d) =>
                  <>
                    <th colspan="2" style={{ textAlign: "center" }}>{d.year}</th>
                  </>
                )}
              </tr>
              <tr >
                <th>Penilaian</th>
                {data.map((d) =>
                  <>
                    {rowHeaders.map((header, index) => (
                      <th>{header}</th>
                    ))}
                  </>
                )}
              </tr>
              <tr>
                <th>ROE (%)</th>
                {data.map((d) =>
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilRoe} </td>
                    <td style={{ textAlign: "right" }}>{d.scoreRoe} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>ROI (%)</th>
                {data.map((d) =>
                  <>

                    <td style={{ textAlign: "right" }}>{d.hasilRoi} </td>
                    <td style={{ textAlign: "right" }}>{d.scoreRoi} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>BOPO (%)</th>
                {data.map((d) =>
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilBopo} </td>
                    <td style={{ textAlign: "right" }}>{d.scoreBopo} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>EBITDA (%)</th>
                {data.map((d) =>
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilEbitda} </td>
                    <td style={{ textAlign: "right" }}>{d.scoreEbitda} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>Cash Ratio (%)</th>
                {data.map((d) =>
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilCashRatio.toString().substring(0,7)} </td>
                    <td style={{ textAlign: "right" }}>{d.scoreCashRatio} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>Current Ratio (%)</th>
                {data.map((d) =>
                
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilCurrentRatio.toString().substring(0,7)} </td>
                    <td style={{ textAlign: "right" }}>{d.scoreCurrentRatio} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>Collection Period (Tahun Buku, Hari)</th>
                {data.map((d) =>
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilPeriodTahunBuku} </td>
                    <td style={{ textAlign: "right" }}>{d.scorePeriodTahunBuku} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>Collection Period (Perbaikan, Hari)</th>
                {data.map((d) =>
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilPeriodPerbaikan} </td>
                    <td style={{ textAlign: "right" }}>{d.scorePeriodPerbaikan} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>TATO (Tahun Buku, %)</th>
                {data.map((d) =>
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilTatoTahunBuku} </td>
                    <td style={{ textAlign: "right" }}>{d.scoreTatoTahunBuku} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>TATO (Perbaikan, %)</th>
                {data.map((d) =>
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilTatoPerbaikan} </td>
                    <td style={{ textAlign: "right" }}>{d.scoreTatoPerbaikan} </td>
                  </>
                )}
              </tr>
              <tr >
                <th>TMS TA (%)</th>
                {data.map((d) =>
                  <>
                    <td style={{ textAlign: "right" }}>{d.hasilTmsTA} </td>
                    <td style={{ textAlign: "right" }}>{d.scoreTmsTA} </td>
                  </>
                )}
              </tr>
            </table>
          )}
          <hr />
        </div>
      </div>
      </div>
      </div>
    </>
  );
};

export default AspekKeuangan;

